/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    Livewire.on('triggerDelete', model => {
        Swal.fire({
            title: 'Anda yakin untuk menghapus item ini?',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak',
            icon: 'warning',
        }).then((result) => {
            if (result.value) {
                Livewire.emit('delete', model);
            }
        });
    });
});
